import React, { useEffect, useState } from "react";
import moment from "moment";
import "./dnview.scss";
import useDebounce from "../../common/debounce";

const DoctorNotes = ({
  element,
  doctorNote,
  doctorsPastNotes,
  setDoctorNote,
  getDoctorsPastNotes,
  prescription_id,
  maxApiCallForNotes,
  handleUpdateAPICall,
}) => {
  const [pageNo, setPageNo] = useState(1);

  const debounceForDoctorNote = useDebounce(doctorNote, 500);

  useEffect(() => {
    if (debounceForDoctorNote?.call_api) {
      handleUpdateAPICall();
    }
  }, [debounceForDoctorNote]);

  const renderNotesInput = () => {
    return (
      <div className="doctor-notes-view-notes">
        <p className="m-0 doctor-notes-view-notes-heading ">
          Doctor Personal Notes
        </p>
        <textarea
          id={element.name}
          maxLength={500}
          rows="6"
          onChange={(e) =>
            setDoctorNote({ call_api: true, value: e.target.value })
          }
          value={doctorNote?.value}
        ></textarea>
      </div>
    );
  };
  const onScrollCall = (e) => {
    let bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom) {
      if (pageNo < maxApiCallForNotes) {
        setPageNo(pageNo + 1);
        getDoctorsPastNotes(prescription_id, pageNo + 1);
      }
    }
  };
  const renderPastNotes = () => {
    return (
      <div className="doctor-notes-past-notes">
        {doctorsPastNotes?.length > 0 && (
          <>
            <p className="m-0">Doctor Notes from past visit's</p>
            <div
              className={`${
                doctorsPastNotes?.length > 1
                  ? "doctor-notes-past-notes-container-set-height pr-1"
                  : ""
              } doctor-notes-past-notes-container pr-1`}
              onScroll={(e) => {
                onScrollCall(e);
              }}
            >
              {doctorsPastNotes?.map((obj, index) => {
                return (
                  <div
                    className="doctor-notes-past-notes-container-box mb-2"
                    key={index}
                  >
                    <div className="doctor-notes-past-notes-container-box-date">
                      <p className="m-0">
                        {moment(new Date(obj?.created_at)).format(
                          "DD MMM YYYY"
                        )}
                      </p>
                    </div>
                    <div className="doctor-notes-past-notes-container-box-content">
                      <p className="m-0"> {obj?.doctor_notes}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="doctor-notes-view">
      {renderNotesInput()}
      {renderPastNotes()}
    </div>
  );
};
export default DoctorNotes;
